/**
 * Switches for agent ↔ agent chat.
 *
 * <p>The feature is probed by USE, not by a flag: the first `GET peer/threads` or
 * `POST peer/threads` tells the client whether the server has it (404 → "not switched on
 * yet"). What lives here is the per-device kill switch — the same shape as
 * `agent-presence-api.ts` — and the one build-time constant the FAB needs while the
 * conversation panels are not yet registered.</p>
 */

/** localStorage key. `off` hides every peer-chat surface on this device; anything else is the default. */
export const PEER_CHAT_OVERRIDE_KEY = 'ielect-peer-chat';

export const peerChatEnabled = (): boolean => {
	try {
		return localStorage.getItem(PEER_CHAT_OVERRIDE_KEY) !== 'off';
	} catch {
		// Storage blocked — the default stands.
		return true;
	}
};

/**
 * Whether the `agent-chat` and `messages-inbox` panels exist in the registry.
 *
 * <p>The panel KEYS are in the `actionComponent` union so hooks can target them, but opening a
 * key that nothing renders shows an empty drawer. Until the panels land this stays false and
 * the FAB routes a peer target to the Help hub instead. Flip it in the same change that
 * registers the components in `global-right-section.tsx`.</p>
 */
export const PEER_PANELS_AVAILABLE = true;
